import styled from 'styled-components';
import { IconPlus } from '@tabler/icons-react';
import { AppFormItem, AppFormItemProps } from 'components/atoms';
import { commonTexts } from 'consts/text';
import { ParentId, SelectOptionType } from 'types';
import { AppCustomSelect } from '../../../atoms/CommonAppComponents/AppSelect/AppCustomSelect/AppCustomSelect';

type SelectProps = {
    value?: ParentId[];
    options: SelectOptionType<ParentId>[];
    onClick?: () => void;
};

type ParentsPickerElementProps = AppFormItemProps & {
    selectProps: SelectProps;
};

const FormItemInnerContainer = styled.div`
    width: 100%;
`;

export const ParentsPickerElement = ({
    selectProps,
    disabled,
    ...restProps
}: ParentsPickerElementProps) => (
    <AppFormItem
        label={commonTexts.forms.selectParent}
        initialValue={[]}
        marginBottom={0}
        disabled={disabled}
        {...restProps}
    >
        <FormItemInnerContainer>
            <AppCustomSelect
                mode="multiple"
                value={selectProps.value}
                options={selectProps.options}
                suffixIcon={<IconPlus size={20} />}
                open={false}
                allowClear={false}
                showSearch={false}
                disabled={disabled}
                onClick={!disabled ? selectProps.onClick : undefined}
                placeholder="Wybierz rodziców"
            />
        </FormItemInnerContainer>
    </AppFormItem>
);
